import React from "react";
import { Mail } from "lucide-react";

const ContactPage: React.FC = () => {
  return (
    <div className="min-h-[calc(100vh-4rem)] bg-slate-50 dark:bg-slate-950 flex items-center justify-center px-4 py-12">
      <div className="max-w-lg w-full">
        <div className="rounded-2xl bg-white/80 dark:bg-slate-900/70 backdrop-blur-sm shadow-lg shadow-slate-900/5 border border-slate-200/60 dark:border-slate-800/80 px-8 py-10 flex flex-col items-center text-center gap-6">
          <div className="inline-flex h-14 w-14 items-center justify-center rounded-full bg-blue-100 dark:bg-blue-500/10 mb-2">
            <Mail className="h-7 w-7 text-[#4C6FFF] dark:text-slate-100" />
          </div>

          <div className="space-y-2">
            <h1 className="text-2xl font-semibold text-slate-900 dark:text-slate-50">
              Contact MixMind Studio
            </h1>
            <p className="text-sm text-slate-600 dark:text-slate-300 max-w-md">
              Nous sommes là pour répondre à vos questions.
            </p>
          </div>

          <div className="mt-4 flex flex-col items-center gap-3 w-full">
            <p className="text-sm font-medium text-slate-700 dark:text-slate-200">
              contact.mixmind@gmail.com
            </p>

            <a
              href="mailto:contact.mixmind@gmail.com"
              className="inline-flex items-center justify-center px-6 py-3 rounded-xl text-sm font-semibold text-white shadow-md shadow-blue-500/30 bg-gradient-to-r from-[#4C6FFF] to-[#7A53FF] hover:from-[#5A7BFF] hover:to-[#8A63FF] focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-blue-500 dark:focus:ring-offset-slate-900 transition w-full sm:w-auto"
            >
              Envoyer un e-mail
            </a>
          </div>

          <p className="mt-6 text-xs text-slate-500 dark:text-slate-400 max-w-md">
            <span className="font-medium">MixMind Studio</span>
            <br />
            Projet éducatif en développement — vos retours nous aident à avancer.
            <br />
            Temps de réponse moyen : 24–48h.
          </p>
        </div>
      </div>
    </div>
  );
};

export default ContactPage;
